import { Box, Button, Stack } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface Props {
  mode: "certificates" | "documents";
  onChangeMode: (mode: "certificates" | "documents") => void;
  children: React.ReactNode;
  isAdmin?: boolean;
  certificateCount?: number;
  documentCount?: number;
}

export default function TableSection({ mode, onChangeMode, children, isAdmin = false, certificateCount = 0, documentCount = 0 }: Props) {
  return (
    <Box
      sx={{
        maxWidth: 1230,
        mx: "auto",
        mt: 2,
        mb: 2,
        borderRadius: 2,
        overflow: "hidden",
        boxShadow: 2,
        background: "#fff",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-around"
        spacing={0}
        sx={{
          borderBottom: "1px solid #e0e0e0",
          background: "#f7f9fc",
        }}
      >
        <Button
          onClick={() => onChangeMode("certificates")}
          variant={mode === "certificates" ? "contained" : "text"}
          sx={{
            width: "50%",
            borderRadius: 0,
            px: 3,
            py: 1.2,
            fontWeight: 700,
            textTransform: "none",
          }}
        >
          Certificados ({certificateCount})
        </Button>
        <Button
          onClick={() => onChangeMode("documents")}
          variant={mode === "documents" ? "contained" : "text"}
          startIcon={!isAdmin ? <LockOutlinedIcon sx={{ fontSize: '1rem !important' }} /> : null}
          sx={{
            borderRadius: 0,
            px: 3,
            width: "50%",
            py: 1.2,
            fontWeight: 700,
            textTransform: "none",
            opacity: !isAdmin ? 0.7 : 1,
            transition: "all 0.2s",
            "&:hover": {

              cursor: !isAdmin ? "not-allowed" : "pointer"
            }
          }}
        >
          Documentos{isAdmin && ` (${documentCount})`}
        </Button>
      </Stack>
      <Box sx={{ p: 0, mt: 2 }}>{children}</Box>
    </Box>
  );
}